import React from "react";
import Register from "../components/Auth/Register";
import PublicHeader from "../components/Layout/PublicHeader";
import Footer from "../components/Layout/Footer";

const RegisterPage = () => {
  return (
    <>
      <PublicHeader />
      <Register />
      <Footer />
    </>
  );
};

export default RegisterPage;
